import { Component, Inject } from "@angular/core";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TimelineItem, TimelineData, Config, CommonService } from 'huddyapi';




@Component({
  selector: 'document-viewer',
  templateUrl: 'document-viewer.html',
  styleUrls: ["./document-viewer.component.scss"]
})
export class DocumentViewer  {
  
  item : TimelineItem;
  itemData : TimelineData;
  safeUrl: SafeResourceUrl;
  containerHeight: number;

  constructor(
    public dialogRef: MatDialogRef<DocumentViewer>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private config: Config,
    private domSanitizer: DomSanitizer
  )
  {
    this.item = data.dataItem;
    this.itemData = data.clickedData[0];
    this.safeUrl = this.getSanitized();
    this.containerHeight = window.innerHeight * .95;
  }

  ngOnInit(): void {

  }

  getSanitized(): SafeResourceUrl {
    let url : string =  this.config.getEndpoint() + '/timeline-doc?id=' + this.itemData.id + "&access_token=" + CommonService.jwt.substring(7);
    return (this.item) ? this.domSanitizer.bypassSecurityTrustResourceUrl(url) : '';
   }
 

  
  close() {  
      this.dialogRef.close();
  }

}



